import { trpc } from "#/lib/trpc/client"
import { HealthieAnswer, markAppointmentFormsComplete } from "@internal/telemedicine"
import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query"

type SubmitIntakeFormVariables = { appointmentId: string; formId: string; answers: HealthieAnswer[] }
type SubmitIntakeFormData = Awaited<ReturnType<typeof trpc.telemedicine.submitForm.mutate>>

export function useSubmitIntakeForm(): UseMutationResult<SubmitIntakeFormData, Error, SubmitIntakeFormVariables> {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ appointmentId, formId, answers }: SubmitIntakeFormVariables) =>
      trpc.telemedicine.submitForm.mutate({ appointmentId, formId, answers }),
    // Flip the "complete forms" CTA (home tile + appointments page) immediately, ahead of the webhook.
    onSuccess: (_data, { appointmentId }) => markAppointmentFormsComplete(queryClient, appointmentId)
  })
}
